import { configureStore, createListenerMiddleware } from '@reduxjs/toolkit'
import habitsReducer from './habits/habitsSlice'
import type { HabitsState } from '../Models/Habit'
import moodReducer from './mood/moodSlice'
import type { MoodState } from './mood/moodSlice'
import commentsReducer from './comments/commentsSlice'
import tasksReducer, { fetchTasks, updateTask } from './tasks/tasksSlice'
import type { CommentsState, TasksState } from '../Models/Task'
import workspaceReducer from './workspace/workspaceSlice'
import type { WorkspaceState } from '../Models/Workspace'

/** After a failed PATCH, reload tasks so optimistic UI matches the server. */
const tasksSyncListener = createListenerMiddleware()
tasksSyncListener.startListening({
  matcher: updateTask.rejected.match,
  effect: async (_action, listenerApi) => {
    await listenerApi.dispatch(fetchTasks())
  },
})

/** Keep keys in sync with `configureStore` below. */
export type RootState = {
  tasks: TasksState
  habits: HabitsState
  mood: MoodState
  comments: CommentsState
  workspace: WorkspaceState
}

export const store = configureStore({
  reducer: {
    tasks: tasksReducer,
    habits: habitsReducer,
    mood: moodReducer,
    comments: commentsReducer,
    workspace: workspaceReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(tasksSyncListener.middleware),
})

export type AppDispatch = typeof store.dispatch
